import { JsonObject } from 'json2typescript';
import { ActivitiesResponseInterface } from '../interfaces/activities-response.interface';
import { OrdersResponseInterface } from '../interfaces/orders-response.interface';
import { ActivityTypeResponseModel } from './activitytype-response.model';

@JsonObject('OrdersResponseModel')
export class OrdersResponseModel implements OrdersResponseInterface {
  AmountExecuted?: number;
  AmountRequested?: number;
  Currency?: string;
  Isin?: string;
  LastDateStatus?: string;
  LastStatus?: string;
  NetPriceExecuted?: number;
  OMSOrderId?: string;
  OperationType?: string;
  OrderDate?: string;
  ProductCode?: string;
  ProductCodeView?: string;
  ProductName?: string;
  TitlesExecuted?: number;
  TitlesRequested?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
